/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef } from 'react';
import './ButtonPrimary.scss';
import { appButtonType, getKeyByValue, appIconsPath } from '@utils/globalConstant';
import PropTypes from 'prop-types';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { sanitizeRichText } from '@utils/sanitizeHtml';
import Icons from '@core/Utils/Icons/Icons';

export function ButtonPrimary({
  children = null,
  iconLeft = null,
  iconRight = null,
  // content from CMS (delivered by tA11y)
  buttonContent = {},
  // label is used when cmsKey is not provided, label is always plain text
  label = '',
  type = 'button',
  buttonType = appButtonType.PRIMARY,
  onClick: onClickProp = () => {},
  isLoading = false,
  tabIndex = 0,
  buttonClass = '',
  btnRef,
  ...restProps
}) {

  // State & Refs
  // const btnRef = useRef(null);
  const buttonIconLeft = getKeyByValue(appIconsPath,iconLeft);
  const buttonIconRight = getKeyByValue(appIconsPath,iconRight);

  // Functions
  const onClick = (event) => {
    if (onClickProp && !isLoading) {
      onClickProp(event);
    }
  };

  const hasValidText = () => {
    if (buttonContent && Object.keys(buttonContent).length > 0) {
      if (buttonContent.content !== "" && buttonContent.content !== undefined) {
        return true;
      }
      return false;
    }
    if (label && label !== '') {
      return true;
    }
    return false
  }

  return (
    <button
      {...(buttonContent.hasAriaLabel && { 'aria-label': buttonContent.ariaLabel })}
      {...(buttonContent.hasAriaDescription && {
        'aria-describedby': buttonContent.ariaDescription
      })}
      tabIndex={tabIndex}
      type={type === 'submit' ? 'submit' : 'button'}
      className={`${buttonType} ${buttonClass} position-relative gap-0 d-inline-flex align-items-center justify-content-center rounded
    `}
      ref={btnRef}
      onClick={onClick}
      // aria-busy={isLoading} // CHECK
      disabled={isLoading}
      {...restProps}>
      {isLoading ? (
        <>
          <div className="btn-loader w-100 py-2 d-inline-flex align-items-center justify-content-center">
            <div
              style={{ width: '20px', height: '20px' }}
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            />
            <span className="visually-hidden">Loading...</span>
          </div>
        </>
      ) : (
        <>
          {iconLeft && <Icons name={buttonIconLeft} height={16} className="btn-icon pe-12" colorType='dark' />}
          { hasValidText() &&
            <>
              {buttonContent.isHtml ? (
                <div
                  className="btn-label"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeRichText(buttonContent.content || label || buttonContent.ariaLabel || 'Button')
                  }}
                />
              ) : (
                <div className="btn-label">
                  {buttonContent.content
                    ? buttonContent.content
                    : label || buttonContent.ariaLabel || 'Button'}
                </div>
              )}
            </>
          }
          {children && <div className="btn-children">{children}</div>}
          {iconRight && <Icons name={buttonIconRight} height={16} className="btn-icon ps-12" colorType='dark' /> }
        </>
      )}
    </button>
  );
}

ButtonPrimary.propTypes = {
  children: PropTypes.node,
  iconLeft: PropTypes.string,
  iconRight: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  buttonType: PropTypes.string,
  onClickProp: PropTypes.func,
  isLoading: PropTypes.bool,
  tabIndex: PropTypes.number,
  cmsKey: PropTypes.string,
};

export default ButtonPrimary;
